const TAR_GZ_EXTENSION = '.tar.gz';
const ARCHIVE_EXTENSIONS = ['.zip', '.tar', TAR_GZ_EXTENSION] as const;
const PLY_EXTENSION = '.ply';

export const SPLAT_UPLOAD_EXTENSIONS = [
  PLY_EXTENSION,
  ...ARCHIVE_EXTENSIONS,
] as const;

/** For file pickers; `.gz` stands in for `.tar.gz`, which browsers do not match. */
export const SPLAT_UPLOAD_ACCEPT = SPLAT_UPLOAD_EXTENSIONS.map((extension) =>
  extension === TAR_GZ_EXTENSION ? '.gz' : extension
).join(',');

export const SPLAT_NAME_MAX_LENGTH = 256;

function matchesExtension(fileName: string, extension: string): boolean {
  return fileName.toLowerCase().endsWith(extension);
}

export function isSplatUploadFile(fileName: string): boolean {
  return SPLAT_UPLOAD_EXTENSIONS.some((extension) =>
    matchesExtension(fileName, extension)
  );
}

/** Archives are extracted by the Splats API (fileset); a PLY is stored as one object. */
export function isSplatArchiveFile(fileName: string): boolean {
  return ARCHIVE_EXTENSIONS.some((extension) =>
    matchesExtension(fileName, extension)
  );
}

export function splatNameFromFileName(fileName: string): string {
  const extension = SPLAT_UPLOAD_EXTENSIONS.find((candidate) =>
    matchesExtension(fileName, candidate)
  );
  const baseName =
    extension === undefined
      ? fileName
      : fileName.slice(0, fileName.length - extension.length);
  return baseName.slice(0, SPLAT_NAME_MAX_LENGTH);
}

/**
 * The Splats API rejects a path already used in the dataset, so each upload
 * gets its own prefix. The extension is kept because the API validates it.
 */
export function createSplatUploadPath(
  fileName: string,
  uniqueId: string = crypto.randomUUID()
): string {
  const safeFileName = fileName.replace(/[^\w.-]/g, '_');
  return `/${uniqueId}-${safeFileName}`;
}
